const BaseUrl = "https://www.kikaiins.com/";
export default BaseUrl;
